module.exports = __webpack_public_path__ + "img/shanshui.96e01bb2.png";